import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheild",
  "use": "icon-sheild-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" id=\"icon-sheild\"><path d=\"M3.50277 4.66666L13.9999 1.16666L24.4972 4.66666C24.4972 4.66666 24.5 8.16666 24.5 15.1667C24.5 22.1667 13.9999 26.8333 13.9999 26.8333C13.9999 26.8333 3.50002 22.1667 3.50001 15.1667C3.5 8.16666 3.50277 4.66666 3.50277 4.66666Z\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M10.5 12.7747L12.9749 15.2495L17.9246 10.2998\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol